import React, { Component } from "react";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import logo from "../../../assets/img/givbeeLogo.png";
import givBeeIcon from "../../../assets/img/givBee_Icon.png";
import "./AdminSidebar.css";
import store from "../../../redux/store";
import AppUserRoleAction from "../../../redux/adminPanel/appUserRole/AppUserRoleAction";
export default class AdminSidebar extends Component {
  constructor(props) {
    super(props);
    let menuList =
      store.getState().adminUserDetails.adminUserDetails?.profile?.menus;
    let adminActiveMenu = store.getState().appUserRole?.adminActiveMenu;

    if (undefined === adminActiveMenu || null === adminActiveMenu) {
      adminActiveMenu = (menuList && menuList.length) > 0 ? menuList[0].id : -1;
    }
    this.handleClick = this.props.handleClick.bind(this);
    this.state = {
      isOpen: true,
      tokenPrice: "",
      menuItems: menuList,
      adminActiveMenu: adminActiveMenu,
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(() => {
      let adminActiveMenu = store.getState().appUserRole?.adminActiveMenu;
      this.setState({ adminActiveMenu: adminActiveMenu });
    });
  }
  componentWillUnmount() {
    this.unsubscribe();
  }

  selectedChildMenu = (menuid) => {
    for (let i = 0; i < this.state.menuItems.length; i++) {
      if (this.state.menuItems[i].id === menuid) {
        store.dispatch(AppUserRoleAction.setAdminActiveMenu(menuid));
        this.setState({ adminActiveMenu: menuid });
      }
    }
  };

  toggleSidebar = () => {
    this.setState({ isOpen: !this.state.isOpen });
    this.handleClick(!this.state.isOpen);

    if (window.innerWidth > 1199) {
      return;
    }
  };

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  render() {
    return (
      <div>
        <aside
          id="layout-menu"
          className={
            this.state.isOpen
              ? "layout-menu menu-vertical adminMenu bg-menu-theme sidebar"
              : "layout-menu menu-vertical adminMenu bg-menu-theme sidenavClosed"
          }
          style={{ height: "100%", backgroundColor: "#1B7D89" }}
        >
          <div className="app-brand demo">
            <Link to="/APDashboard" className="app-brand-link">
              {this.state.isOpen ? (
                <span className="app-brand-logo demo">
                  <div
                    style={{
                      borderRadius: "5px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <img
                      src={logo}
                      className="img-fluid"
                      alt=""
                      style={{
                        padding: "5px",
                        width: "200px",
                        height: "50px",
                        objectFit: "contain",
                      }}
                      data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                      data-app-light-img="illustrations/girl-with-laptop-light.png"
                    />
                  </div>
                </span>
              ) : (
                <span
                  className="app-brand-logo demo"
                  style={{ marginLeft: "-15px" }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      height: "60px",
                      width: "60px",
                    }}
                  >
                    <img
                      src={givBeeIcon}
                      className="img-fluid"
                      alt=""
                      style={{
                        padding: "10px 0px 0px 10px",
                        height: "50px",
                        width: "50px",
                      }}
                      data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                      data-app-light-img="illustrations/girl-with-laptop-light.png"
                    />
                  </div>
                </span>
              )}
            </Link>
            <div
              className="layout-menu-toggle menu-link text-large sidebar-toggle"
              style={{ left: this.state.isOpen ? "15rem" : "5.1rem" }}
              onClick={this.toggleSidebar}
            >
              <Tooltip
                title={this.state.isOpen ? "Collapse" : "Expand"}
                classes={{ popper: "custom-tooltip" }}
              >
                <i
                  className="bx bx-chevron-left bx-sm align-middle z-1"
                  style={{
                    transform: this.state.isOpen
                      ? "rotateY(0deg)"
                      : "rotateY(180deg)",
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className="menu-inner-shadow" />
          <ul className="menu-inner py-1 pt-4">
            {this.state.menuItems
              ?.sort((a, b) => a.displaysequence - b.displaysequence)
              .map((m, key) => {
                if (!this.isEmpty(m)) {
                  let isactive = false;
                  if (m.id === this.state.adminActiveMenu) {
                    isactive = true;
                  }
                  return m.isactive === true ? (
                    <Link
                      key={key}
                      to={m.pageid}
                      onClick={this.selectedChildMenu.bind(this, m.id)}
                      className={
                        isactive === true ? "menu-item active" : "menu-item"
                      }
                      style={{ width: this.state.isOpen ? "250px" : "90px" }}
                    >
                      <div className="menu-link apMenu-link" style={{ color: "#fff" }}>
                        {this.state.isOpen ? (
                          <>
                            <i
                              className={`menu-icon tf-icons ${m.icon}`}
                              style={{ fontSize: "22px" }}
                            />
                            <div
                              className="link_text text-start"
                            >
                              {m.uiname}
                            </div>
                          </>
                        ) : (
                          <Tooltip title={m.uiname}>
                            <i
                              className={`menu-icon tf-icons ${m.icon}`}
                              style={{ fontSize: "22px" }}
                            />
                          </Tooltip>
                        )}
                      </div>
                    </Link>
                  ) : (
                    <div></div>
                  );
                }
              })}
          </ul>
        </aside>
      </div>
    );
  }
}
